"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Remove;

var _Remove = require("@adobe/react-spectrum-workflow/dist/Remove");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function Remove(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_Remove.A4uRemove, null));
}